import Cookies from 'js-cookie'

export const platform = "custom"
const TokenKey = platform + "_" + 'Admin-Token'

const ExpiresInKey = platform + "_" + 'Admin-Expires-In'
const TokenBrowserKey = platform + "_" + 'Browser-Finger'


export function getToken() {
    return Cookies.get(TokenKey)
}

export function setToken(token) {
    return Cookies.set(TokenKey, token)
}

export function removeToken() {
    return Cookies.remove(TokenKey)
}

export function getExpiresIn() {
    return Cookies.get(ExpiresInKey) || -1
}

export function setExpiresIn(time) {
    return Cookies.set(ExpiresInKey, time)
}

export function removeExpiresIn() {
    return Cookies.remove(ExpiresInKey)
}


// 
export function getBrowserToken() {
    return sessionStorage.getItem(TokenBrowserKey)
}

export function setBrowserToken(token) {
    sessionStorage.setItem(TokenBrowserKey, token)
}

export function removeBrowserToken() {
    sessionStorage.removeItem(TokenBrowserKey)
}
